module.exports = __webpack_public_path__ + "img/check_icon.71544e78.svg";